var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.pageTitle) + "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "changeProfile" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            name: "locationId",
                            id: "locationId",
                            label: "text",
                            filterable: false,
                            options: _vm.locationArr,
                            placeholder: "Select State"
                          },
                          on: {
                            change: _vm.changedValueLoc,
                            input: function($event) {
                              return _vm.changedValueLocation()
                            },
                            search: _vm.onSearchLocation
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function(option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(option.text) +
                                        "\n                                        "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "selected-option",
                              fn: function(option) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "selected d-center" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(option.text) +
                                          "\n                                        "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.locationId,
                            callback: function($$v) {
                              _vm.locationId = $$v
                            },
                            expression: "locationId"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              "\n                                        Search State...\n                                    "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.locationError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "locationType",
                          id: "locationType",
                          label: "text",
                          clearable: false,
                          searchable: false,
                          filterable: false,
                          options: _vm.locationTypeArr,
                          placeholder: "Select Location Type"
                        },
                        model: {
                          value: _vm.locationType,
                          callback: function($$v) {
                            _vm.locationType = $$v
                          },
                          expression: "locationType"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.videoTitle,
                            expression: "videoTitle"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "videoTitle",
                          placeholder: "Button Title"
                        },
                        domProps: { value: _vm.videoTitle },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.videoTitle = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.buttonTitleError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row col-12 desc",
                    attrs: { id: "uploadSelected2" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 forms-block",
                        attrs: { id: "myForm" }
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 paddingleft0" },
                          [
                            _c("vue-dropzone", {
                              ref: "dropzone",
                              attrs: {
                                id: "drop1",
                                options: _vm.dropzoneOptions,
                                destroyDropzone: false,
                                headers: _vm.dropzoneOptions.headers,
                                name: "file"
                              },
                              on: {
                                "vdropzone-removed-file":
                                  _vm.removedSelectedFile,
                                "vdropzone-success": _vm.vfileSuccess,
                                "vdropzone-duplicate-file": _vm.vduplicateFile,
                                "vdropzone-total-upload-progress":
                                  _vm.progressOfUload
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.videoURLError))
                            ]),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _c("strong", {
                                staticClass: "error text-danger",
                                attrs: { id: "errorMsg2" }
                              })
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row col-12 desc",
                    staticStyle: { display: "none" },
                    attrs: { div: "", id: "uploadSelected3" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 forms-block",
                        attrs: { id: "myForm" }
                      },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 paddingleft0" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.videoURL,
                                  expression: "videoURL"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "videoURL",
                                placeholder: "Button URL"
                              },
                              domProps: { value: _vm.videoURL },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.videoURL = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("font", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.videoURLError))
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "col-12 paddingleft0" }, [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addBenifitBtn",
                        type: "submit",
                        value: "Save"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addBenefitGlance()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addAndContinueBenifitBtn",
                        type: "submit",
                        value: "Save and Continue"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addBenefitGlance(
                            (_vm.flag = "Save and Continue")
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "back_button btn btn-primary",
                      attrs: {
                        id: "CancelBenifit",
                        type: "submit",
                        value: "Cancel"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.buttonBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationId" } }, [
        _vm._v("State :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationType" } }, [
        _vm._v("Location Type :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "videoTitle" } }, [
        _vm._v("Button Title :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 forms-block", attrs: { id: "myForm" } },
      [
        _c("div", { staticClass: "col-3 paddingleft0" }, [
          _c(
            "div",
            { staticClass: "form-label", attrs: { for: "videoTitle" } },
            [_vm._v("Type :")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 paddingleft0" }, [
          _c("label", [
            _c("input", {
              attrs: {
                type: "radio",
                name: "cars",
                value: "2",
                checked: "checked"
              }
            }),
            _vm._v("Upload Doc")
          ]),
          _vm._v(" "),
          _c("label", [
            _c("input", { attrs: { type: "radio", name: "cars", value: "3" } }),
            _vm._v("Enter URL")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "videoTitle" } }, [
        _vm._v("Upload Document :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "videoURL" } }, [
        _vm._v("Button URL :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fceeafc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fceeafc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/benefits/AddBenefitGlance.vue
// module id = null
// module chunks = 